import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid"
import Link from "@mui/material/Link";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

export const ReceiptColumns: GridColDef[] = [
    { 
        field: 'date', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography> 
        ),
    },
    { 
        field: 'fullNameReverse', 
        headerName: 'Contributor', 
        headerAlign: 'left', 
        align: 'left',
        minWidth: 200,
        flex: 1.2,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2" fontWeight={600}>{params.value}</Typography>
                <Typography component="i"  variant="subtitle2">{params.row.streetAddress} {params.row.city} {params.row.state} {params.row.zipCode}</Typography>
            </>            
        ),
    },
    { 
        field: 'occupation', 
        headerName: 'Occupation / Employer', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 200,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">{params.value}</Typography>
                <Typography component={'i'} variant="subtitle2">{params.row.employer}</Typography>
            </>         
        ),
    },
    { 
        field: 'amount', 
        headerName: 'Amount', 
        headerAlign: 'center',
        align: 'right',
        width: 150,
        //flex: 1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2" fontWeight={550}>{params.value}</Typography>        
        ),
    },
    { 
        field: 'filerFullNameReverse', 
        headerName: 'Recipient/Source', 
        headerAlign: 'left',
        align: 'left',
        //flex: 2,
        width: 250,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">
                    <Typography component={Link} href={`/filers?q=${params.row.filerCpfId}`} target="_blank" underline="none" variant="body2">{params.row.filerCpfId}</Typography> {params.value}
                </Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="none" variant="body2"><i>{params.row.sourceDescription}</i></Typography>
            </>  
        ),
    },
    /*
    { 
        field: 'city', 
        headerName: 'City', 
        headerAlign: 'left', 
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    { 
        field: 'state', 
        headerName: 'State', 
        headerAlign: 'center', 
        align: 'center',
        flex: 1,
        minWidth: 60,
    },
    { 
        field: 'zipCode', 
        headerName: 'Zip', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
        sortable: false,
    },
    */
    /*
    { 
        field: 'employer', 
        headerName: 'Employer', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>        
        ),
    },
    */ 
    { 
        field: 'sourceDescription', 
        headerName: 'Source', 
        headerAlign: 'left',
        align: 'left',
        //flex: 1,
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="none" variant="body2">{params.value}</Typography>
        ),
    }
]

export const ExpenditureColumns: GridColDef[] = [
    { 
        field: 'date', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>          
        ),
    },
    { 
        field: 'vendor', 
        headerName: 'Vendor', 
        headerAlign: 'left', 
        align: 'left',
        flex: 1.2,
        minWidth: 180,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2" fontWeight={550}>{params.value}</Typography>
                <Typography component="i"  variant="subtitle2" color={"primary"}>{params.row.clarifiedName}</Typography>
                <Typography component="i"  variant="subtitle2">{params.row.streetAddress} {params.row.city} {params.row.state} {params.row.zipCode}</Typography>
            </>            
        ),
    },
    
    { 
        field: 'purpose', 
        headerName: 'Purpose', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">{params.value}</Typography>
                <Typography component="i"  variant="subtitle2" color={"primary"}>{params.row.clarifiedPurpose}</Typography>
            </>            
        ),
    },
    { 
        field: 'amount', 
        headerName: 'Amount', 
        headerAlign: 'right',
        align: 'right',
        width: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2" fontWeight={550}>{params.value}</Typography>        
        ),
    },
    { 
        field: 'filerFullNameReverse', 
        headerName: 'Filer/Source', 
        headerAlign: 'left',
        align: 'left',
        width: 250,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">
                    <Typography component={Link} href={`/filers?q=${params.row.filerCpfId}`} target="_blank" underline="none" variant="body2">{params.row.filerCpfId}</Typography> {params.value}
                </Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="none" variant="body2"><i>{params.row.sourceDescription}</i></Typography>
            </>  
        ),
    },
    /*
    { 
        field: 'city', 
        headerName: 'City', 
        headerAlign: 'left', 
        align: 'left',
        flex: 1,
        minWidth: 120,
    },
    { 
        field: 'state', 
        headerName: 'State', 
        headerAlign: 'center', 
        align: 'center',
        flex: 1,
        minWidth: 60,
    },
    { 
        field: 'zipCode', 
        headerName: 'Zip', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
        sortable: false,
    },
    */
    { 
        field: 'sourceDescription', 
        headerName: 'Source', 
        headerAlign: 'left',
        align: 'left',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="none">{params.value}</Link>
        ),
    }
]

export const SubvendorPaymentColumns: GridColDef[] = [
    { 
        field: 'date', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>          
        ),
    },
    { 
        field: 'subvendorName', 
        headerName: 'Sub-Vendor', 
        headerAlign: 'left', 
        align: 'left',
        flex: 1,
        minWidth: 180,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2" fontWeight={550}>{params.value}</Typography>
                <Typography component="i"  variant="subtitle2">{params.row.streetAddress} {params.row.city} {params.row.state} {params.row.zipCode}</Typography>
            </>            
        ),
    },
    { 
        field: 'vendorName', 
        headerName: 'Vendor', 
        headerAlign: 'left', 
        align: 'left',
        flex: 1,
        minWidth: 180,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">{params.value}</Typography>
            </>            
        ),
    },
    { 
        field: 'purpose', 
        headerName: 'Purpose', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">{params.value}</Typography>
                <Typography component="i"  variant="subtitle2" color={"primary"}>{params.row.clarifiedPurpose}</Typography>
            </>            
        ),
    },
    { 
        field: 'amount', 
        headerName: 'Amount', 
        headerAlign: 'right',
        align: 'right',
        width: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2" fontWeight={550}>{params.value}</Typography>        
        ),
    },
    { 
        field: 'filerFullNameReverse', 
        headerName: 'Filer/Source', 
        headerAlign: 'left',
        align: 'left',
        width: 250,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Typography variant="subtitle2">
                    <Typography component={Link} href={`/filers?q=${params.row.filerCpfId}`} target="_blank" underline="none" variant="body2">{params.row.filerCpfId}</Typography> {params.value}
                </Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="none" variant="body2"><i>{params.row.sourceDescription}</i></Typography>
            </>  
        ),
    },
    { 
        field: 'sourceDescription', 
        headerName: 'Source', 
        headerAlign: 'left',
        align: 'left',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="none">{params.value}</Link>
        ),
    }
]